import { render } from "./MentorQuestions.vue?vue&type=template&id=7070ca10&scoped=true"
import script from "./MentorQuestions.vue?vue&type=script&lang=js"
export * from "./MentorQuestions.vue?vue&type=script&lang=js"

import "./MentorQuestions.vue?vue&type=style&index=0&id=7070ca10&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7070ca10"]])

export default __exports__